import * as types from './actionTypes';

export const loadDashboardSettings = dashboard => ({ type: types.DASHBOARD_SETTINGS, dashboard });

export const loginRequest = id => ({ type: types.LOGIN_REQUEST, id });
export const loginSucceeded = payload => ({ type: types.LOGIN_SUCCEEDED, payload });
